import { cn } from '@/lib/utils';

export type StatusType =
  | 'unpaid'
  | 'paid'
  | 'ready_to_process'
  | 'processing'
  | 'not_yet_shipped'
  | 'shipping'
  | 'done'
  | 'cancel'
  | 'cancelled'
  | 'expired';

type BadgeStatusProps = {
  status?: string;
  className?: string;
};

const getStatusStyles = (status: string) => {
  switch (status) {
    case 'unpaid':
      return statusStyles.secondary;
    case 'paid':
    case 'ready_to_process':
    case 'processing':
    case 'not_yet_shipped':
    case 'shipping':
      return statusStyles.info;
    case 'done':
      return statusStyles.primary;
    case 'cancel':
    case 'cancelled':
    case 'expired':
      return statusStyles.error;
    default:
      return statusStyles.secondary;
  }
};

const statusStyles = {
  secondary: {
    container: 'bg-[#F2F2F2] text-[#A3A3A3]',
    dot: 'bg-[#A3A3A3]',
  },
  info: {
    container: 'bg-[#F3EEFF] text-[#6E45C4]',
    dot: 'bg-[#6E45C4]',
  },
  primary: {
    container: 'bg-[#DBEFDC] text-[#329536]',
    dot: 'bg-[#329536]',
  },
  error: {
    container: 'bg-red-100 text-red-600',
    dot: 'bg-red-400',
  },
};

const formatStatusText = (status: string = 'unknown') => status.replaceAll('_', ' ');

export function BadgeStatus({ status, className }: BadgeStatusProps) {
  const styles = getStatusStyles(status as string);

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium',
        styles.container,
        className
      )}
    >
      <div className={cn('h-2 w-2 rounded-full', styles.dot)} />
      <span className='capitalize'>{formatStatusText(status)}</span>
    </div>
  );
}

BadgeStatus.defaultProps = {
  status: 'unknown',
};
